import { DogmaGraphData, DogmaDetailsTabData, DogmaTableData } from './DogmaInterface';

interface DogmaAggregatedData {
  dogmaGraphData: DogmaGraphData;
  dogmaDetailsTabData?: DogmaDetailsTabData;
}

export const aggregateDogmaSummaryData = (dogmaData: DogmaAggregatedData) => {
  // Aggregate Dogma data for AI summary
  const totalAggregatedViolationsByManager = dogmaData.dogmaDetailsTabData?.totalAggregatedViolationsByManager;
  return {
    dogmaGraphData: dogmaData.dogmaGraphData || ({} as DogmaGraphData),
    totalAggregatedViolationsByManager:
      totalAggregatedViolationsByManager === undefined
        ? dogmaData.dogmaDetailsTabData
          ? undefined
          : ({} as DogmaTableData)
        : totalAggregatedViolationsByManager || ({} as DogmaTableData)
  };
};
